// Subtle hexagonal motif — Queen B Hive brand accent
// Use sparingly as decorative background or accent on section headers

export const HexPattern = ({ className = "", opacity = 0.04, color = "#D4AF37" }) => (
  <svg
    className={`pointer-events-none absolute inset-0 ${className}`}
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <defs>
      <pattern id="hex-pattern" x="0" y="0" width="56" height="48" patternUnits="userSpaceOnUse">
        <path
          d="M28 0 L56 16 L56 32 L28 48 L0 32 L0 16 Z"
          fill="none"
          stroke={color}
          strokeWidth="1"
          opacity={opacity}
        />
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#hex-pattern)" />
  </svg>
);

export const HexAccent = ({ size = 24, color = "#D4AF37", className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 24"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M14 0 L28 8 L28 16 L14 24 L0 16 L0 8 Z"
      fill="none"
      stroke={color}
      strokeWidth="1.5"
    />
  </svg>
);

export default HexPattern;
